var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "i-repeat" },
    [
      _vm._l(_vm.items, function (item, index) {
        return [
          !item.hidden
            ? _c(
                "li",
                {
                  key: index,
                  staticClass: "i-repeat-li",
                  class: `${_vm.liClass}`,
                  attrs: { id: item?.id },
                },
                [_vm._t("default", null, { item: item })],
                2
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }